import * as Combobox from '@givebutter/primitives/combobox';
import { InstallmentFrequency } from 'constants/pledges';

const PledgeFrequencyOptions = () => (
    <>
        <Combobox.Item value={InstallmentFrequency.OneTime}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>One-time</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.Weekly}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Weekly</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.Monthly}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Monthly</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.Quarterly}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Quarterly</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.SemiAnnually}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Semi-annually</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.Annually}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Annually</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={InstallmentFrequency.Custom}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Custom</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { PledgeFrequencyOptions };
